<template>
  <div class="big">
    <div class="page_title">专科门诊</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>专科门诊名称</span>
            <el-input
              placeholder="请输入"
              v-model="sd_name"
              style="width: 160px; margin-left: 8px"
              clearable=""
              @change="search"
            ></el-input>
            <el-button
              type="info"
              @click="search"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 10px;
              "
              >查询</el-button
            >
          </div>
          <el-button
            type="primary"
            @click="addClinic"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1440') : false
            "
            >添加专科门诊
          </el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="专科门诊名称" prop="sd_name">
            </el-table-column>
            <el-table-column label="专科门诊说明" prop="sd_desc">
            </el-table-column>
            <el-table-column label="展示图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.sd_image_str"
                  alt
                  style="width: 160px; height: 90px"
                />
              </template>
            </el-table-column>
            <el-table-column label="专科门诊引导语" width="260">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.title" :key="index">
                  {{ item.length > 15 ? item.substring(0, 15) + "..." : item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="推荐关键词" prop="keywords_name">
            </el-table-column>
            <el-table-column label="最后编辑时间" prop="update_time">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="
                    linkDia(scope.row.app_link_url, scope.row.applet_link_url)
                  "
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1445')
                      : false
                  "
                  >链接</el-button
                >
                <el-button
                  @click="editClinic(scope.row.sd_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1441')
                      : false
                  "
                  >编辑</el-button
                >
                <el-button
                  @click="delClinic(scope.row.sd_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1442')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="链接"
      :visible.sync="linkdia"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <div style="margin-bottom: 20px">
          <span>App链接：</span>
          <span>{{ app_link_url }}</span>
          <el-button
            style="margin-left: 15px"
            type="primary"
            size="mini"
            @click="copyUrl(app_link_url)"
            >复制
          </el-button>
        </div>
        <div>
          <span>小程序链接：</span>
          <span>{{ applet_link_url }}</span>
          <el-button
            style="margin-left: 15px"
            type="primary"
            size="mini"
            @click="copyUrl(applet_link_url)"
            >复制
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      sd_name: "",
      linkdia: false,
      type: "",
      app_link_url: "",
      applet_link_url: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取banner列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        sd_name: this.sd_name,
      };
      this.axios
        .post("platform/guidance/specialtyDepartmentList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = dayjs
                .unix(item.update_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //链接弹窗
    linkDia(app_link_url, applet_link_url) {
      this.app_link_url = app_link_url;
      this.applet_link_url = applet_link_url;
      this.linkdia = true;
    },
    //复制链接
    copyUrl(url) {
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    //删除
    delClinic(sd_id) {
      this.$confirm("您确定删除该专科门诊吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/guidance/deleteSpecialtyDepartment", { sd_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("删除成功");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //添加
    addClinic() {
      this.$router.push("AddAndEdit");
    },
    //编辑
    editClinic(sd_id) {
      this.$router.push({
        path: "AddAndEdit",
        query: {
          sd_id,
        },
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 30px;
  text-align: left;
}
</style>
